module.exports = ".mdi-close-circle-o{\n    font-size: 48px;\n    color: #e04545;\n}\n\n.mdi-email{\n    font-size: 60px !important;\n    color: #4285f4;\n}"